<template>
  <div>
    <h5>
      <strong>{{ $t("name") }}:</strong> {{ title }}
      <span class="ml-5" v-if="supervisor"
        ><strong> Supervisor:</strong> {{ supervisor.username }}</span
      >
    </h5>
    <v-divider />
    <form>
      <v-row>
        <v-col cols="12" md="6">
          <v-combobox
            v-model="workplaceSelected"
            :items="workplaces"
            item-text="name"
            :label="$t('label.laboratory')"
            return-object
            hide-details
            outlined
            readonly
          ></v-combobox>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="investigator.workplaceAssignation.expiration_date"
            label="Expiration date"
            prepend-inner-icon="event"
            readonly
            hide-details
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="investigator.workplaceAssignation.change_date"
            label="Change date"
            prepend-inner-icon="event"
            readonly
            disabled
            hide-details
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-checkbox
            v-model="investigator.workplaceAssignation.change_fast"
            label="Change date as soon as possible"
            :false-value="false"
            :true-value="true"
            readonly
          />
        </v-col>
      </v-row>
      <v-divider />
      <DirectorActions v-if="isAuthorize" :object_type="object_type" />
      <SupervisorActions
        v-else
        :item="investigator"
        :object_type="object_type"
        :form_name="form_name"
        :state="state"
        :supervisor="supervisor !== null ? supervisor.username : ''"
        @change-state-supervisor="onStateSupervisorChange"
      />
    </form>
  </div>
</template>

<script>
import axios from "axios";
import DirectorActions from "../../action_buttons/DirectorActions";
import SupervisorActions from "../../action_buttons/SupervisorActions";
import investigator_model from "../../../mixins/model_utils/investigator_model";
import investigatorData from "../../../mixins/investigator_data";
export default {
  mixins: [investigatorData, investigator_model],
  components: { DirectorActions, SupervisorActions },

  data: () => ({
    menu: false,
    menu_exp_date: false,
    object_type: "",
    state: "",
    supervisor: "",
    title: "",
    form_name: "",
    reject_comment: "",
    workplaceSelected: ""
  }),

  created() {
    this.getWorkplaces();
    this.getData();
  },

  computed: {
    isAuthorize() {
      return this.$route.meta.authorize !== undefined;
    }
  },

  methods: {
    getData() {
      let path;
      if (this.isAuthorize) {
        path =
          this.$store.state.endpoint +
          "/direction/moderatedOperations/authorize/investigator/" +
          this.$route.params.id;
      } else {
        path =
          this.$store.state.endpoint +
          "/moderatedOperations/review/investigator/" +
          this.$route.params.id;
      }
      axios
        .get(path)
        .then(response => {
          this.investigator.workplaceAssignation =
            response.data.data.user.workplaceAssignation;
          this.reject_comment = response.data.reject_comment;
          this.form_name = response.data.form_name;
          this.title = response.data.title;
          this.state = response.data.state;
          this.supervisor = response.data.supervisor;
          this.object_type = response.data.object_type;
          this.investigator.id = response.data.object_id;
          this.getInvestigatorName(
            this.$store.state.endpoint + "/person/" + this.investigator.id
          );
          this.loadWorkplaceSelected(this.investigator.workplaceAssignation.id);
        })
        .catch(error => {
          console.log(error);
        });
    },

    loadWorkplaceSelected(item) {
      if (typeof item == "number") {
        this.workplaceSelected = this.workplaces.filter(
          workplace => workplace.id === item
        )[0];
      } else {
        this.workplaceSelected = item;
      }
    },

    onStateSupervisorChange(state, supervisor) {
      this.state = state;
      this.supervisor = supervisor;
    }
  }
};
</script>
